export const saveItemInLocalStorage = (item, value) => {
  window.localStorage.setItem(item, JSON.stringify(value))
}

export const getItemFromLocalStorage = (item) => {
  const foundItem = window.localStorage.getItem(item)
  if (foundItem) return JSON.parse(foundItem)
  return null
}

export const removeItemFromLocalStorage = (item) => {
  window.localStorage.removeItem(item)
}

export const saveItemInSessionStorage = (item, value) => {
  window.sessionStorage.setItem(item, JSON.stringify(value))
}

export const getItemFromSessionStorage = (item) => {
  const foundItem = window.sessionStorage.getItem(item)
  if (foundItem) return JSON.parse(foundItem)
  return null
}

export const removeItemFromSessionStorage = (item) => {
  window.sessionStorage.removeItem(item)
}
